<div class="header">
  <div>
    <span class="object-name">
      {{ attributes.id }}
    </span>
    @if (attributes.iata) {
      <span class="secondary-info">
        / {{ attributes.iata }}</span
        >
      }
    </div>
    <div class="sub-header">
      {{ attributes.name }}
    </div>
  </div>
  <div id="info-block" class="info-container">
    @if (attributes.location) {
      <div class="info">
        <p class="field-title">Location</p>
        {{ attributes.location }}
      </div>
    }
    <div class="info">
      <p class="field-title">Coordinates</p>
      {{ attributes.coordinates }}
    </div>
    <div class="info">
      <p class="field-title">Elevation</p>
      {{ attributes.elevation }}
    </div>
    <div class="info">
      <p class="field-title">Time Zone</p>
      {{ attributes.timezone }}
    </div>
    @if (attributes.daylightSavings) {
      <div class="info italics">
        Daylight Savings Time Observed
      </div>
    }

    <!-- Add Runways here -->
  </div>
